import { css } from 'styled-components';
import { Device, from } from './media';
export default {
    navHeight: '70px',
    navHeightSmall: '55px',
    contentPadding: '22px',
    /** This value is not absolute, but can be reduced the height of the main content to pull the footer just enough into view */
    footerHeight: '284px',
    rootMargin: '0px 0px -20% 0px',
};
export const zIndex = {
    navigation: 102,
    stickyNavigation: 101,
    contentOverlay: 3,
    aboveContent: 2,
    popup: 103,
    modal: 100000,
    priorityPopUp: 110,
};
export const ButtonReset = css `
  border: none;
  outline: none;
  padding: 0px;
  background: none;
  border-radius: 0px;
`;
export const StandardContentMargin = css `
  margin: 45px 0px;

  @media ${from(Device.Tablet)} {
    margin: 60px 0px;
  }

  @media ${from(Device.DesktopLarge)} {
    margin: 90px 0px;
  }
`;
export const emptyDataUri = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
